import * as React from 'react';
import { ReactChild } from 'react';

type ComboBoxDefaultItemProps = {
    children: ReactChild,
    /** paddingLeft for content E.g: "12px" */
    paddingLeft?: string,
    /** paddingRight for content E.g: "12px" */
    paddingRight?: string,
};

function ComboBoxDefaultItem({ children, paddingLeft, paddingRight }: ComboBoxDefaultItemProps) {
    const style = {
        paddingLeft: paddingLeft || '8px',
        paddingRight: paddingRight || '8px',
    };

    return <div style={style}>{children}</div>;
}

export default ComboBoxDefaultItem;